// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles-module__loader___YSJa1{margin:100px;text-align:center}`, "",{"version":3,"sources":["webpack://./src/components/Fallback/styles.module.scss"],"names":[],"mappings":"AAAA,+BACE,YAAA,CACA,iBAAA","sourcesContent":[".loader {\r\n  margin: 100px;\r\n  text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var loader = `styles-module__loader___YSJa1`;
export default ___CSS_LOADER_EXPORT___;
